import {useState, useCallback, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import BackupCodes from './BackupCodes'
import TfaIntro from './TfaIntro'
import TfaSetup from './TfaSetup'

import {connect} from '../../../state/hooks/tools'
import {ROLES, SETTINGS, TFA_CONFIG, TFA_ENROLLMENTS} from '../../../state/actionTypes'
import {updateResource, createResource, readEndpoint, deleteResource} from '../../../lib/asyncMethods'
import {isEmpty} from '../../../lib/tools'
import {filterRecordsByAttribute} from '../../../lib/data'
import {holdsTfaBypass} from '../../../lib/featureFlags'

const TfaSetupController = props => {
  const [mode, setMode] = useState('intro')
  const [enrollment, setEnrollment] = useState({})
  const [backupCodes, setBackupCodes] = useState([])
  const navigate = useNavigate()

  // Sign-in never sends an exempt account here, so arriving is someone typing the address. A bypass
  // this account holds says it does not use 2FA at all, on or off, and there is no config for a
  // setup to finish against either way. Roles come along for the same reason sign-in reads them:
  // the settings listing an admin is handed carries other accounts' flags.
  useEffect(() => {
    Promise.all([props.readSettings('settings'), props.readRoles('roles')]).then(([settings, roles]) => {
      if (holdsTfaBypass({settings: settings.data, roles: roles.data}))
        navigate('/auth/sign-in', {replace: true})
    })
  }, [])

  useEffect(() => {
    // Cleanup any existing enrollments that are not enabled
    props.readEndpoint('tfa-enrollments').then(response => {
      if (response.success && !isEmpty(response.data)) {
        response.data.forEach(enrollment => {
          if (!enrollment.enabledAt)
            props.deleteResource(`tfa-enrollments/${enrollment.id}`)
        })
      }
    })
  }, [])

  const enableTfa = () => {
    props.updateResource({
      endpoint: `tfa-configs/${props.tfa.id}`,
      attributes: {
        status: 'enable',
        enrollmentId: enrollment.id
      }
    }).then(response => {
      if (response.success)
        navigate('/auth/sign-in')
    })
  }

  const validateOtp = data => {
    props.updateResource({
      endpoint: `tfa-configs/${props.tfa.id}`,
      attributes: {
        ...data,
        status: 'validate',
        enrollmentId: enrollment.id
      }
    }).then(response => {
      if (response.success) {
        setBackupCodes(filterRecordsByAttribute({records: response.included, attribute: 'type', id: 'backup-codes'}))
        setMode('backup')
      } else {
        console.log(response)
      }
    })
  }

  const startEnrollment = useCallback(
    () => {
      props.createResource({
        endpoint: 'tfa-enrollments',
        attributes: {
          name: 'Authenticator App',
          category: 'primary',
          mode: 'app'
        }
      }).then(response => {
        if (response.success) {
          setEnrollment(response.data)
          setMode('setup')
        } else {
          console.log(response)
        }
      })
    },
    [props.createResource]
  )

  switch (mode) {
    case 'setup':
      return (
        <TfaSetup
          validateOtp={validateOtp}
          loading={props.loading}
          enableTfa={enableTfa}
          tfaConfig={props.tfa}
          tfaEnrollments={props.tfaEnrollments}
        />
      )
    case 'backup':
      return <BackupCodes backupCodes={backupCodes} enableTfa={enableTfa} />
    default:
      return <TfaIntro loading={props.loading} onStart={startEnrollment} />
  }
}

const mapStateToProps = state => {
  const tfa = !isEmpty(state.tfa?.tfa) ? {...state.tfa} : {tfa: state.auth?.user, loading: false}

  return {...tfa, ...state.tfaEnrollment}
}

const actionCreators = dispatchs => ({
  updateResource: updateResource(dispatchs.tfa, TFA_CONFIG),
  readSettings: readEndpoint(dispatchs.metadata, SETTINGS),
  readRoles: readEndpoint(dispatchs.roles, ROLES),
  createResource: createResource(dispatchs.tfaEnrollment, TFA_ENROLLMENTS),
  readEndpoint: readEndpoint(dispatchs.tfaEnrollment, TFA_ENROLLMENTS),
  deleteResource: deleteResource(dispatchs.tfaEnrollment, TFA_ENROLLMENTS)
})

export default connect(mapStateToProps, actionCreators)(TfaSetupController)
